import { DashboardHomeSection } from "./dashboard-sections/DashboardHomeSection";
import { DashboardOrdersSection } from "./dashboard-sections/DashboardOrdersSection";
import { DashboardContactSection } from "./dashboard-sections/DashboardContactSection";
import { DashboardMetricsSection } from "./dashboard-sections/DashboardMetricsSection";
import { useIsRekom, useIsWarner } from "../../util";

export const Dashboard = () => {
  const isRekom = useIsRekom();
  const isWarner = useIsWarner();

  return (
    <div className="container mt-7">
      <DashboardHomeSection />
      {!isRekom && !isWarner && (
        <>
          <DashboardMetricsSection />
          <DashboardOrdersSection />
        </>
      )}
      <DashboardContactSection />
    </div>
  );
};
